import { useEffect, useState } from "react";
import { api, errText } from "../../lib/api";
import { LegalDoc } from "../Legal";
import { ShieldCheck } from "lucide-react";

const T = {
  title: "Mise à jour de nos conditions",
  intro: "Nos conditions ont été mises à jour. Merci de les lire et de les accepter pour continuer à utiliser votre espace fleuriste.",
  accept: "J'ai lu et j'accepte les documents ci-dessus, au nom de ma boutique.",
  button: "Accepter et continuer",
  version: "Version",
};

export default function LegalGate({ locale = "fr", onAccepted }) {
  const [docs, setDocs] = useState(null);
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/legal/florist/pending", { params: { locale } })
      .then((r) => setDocs(r.data.documents || []))
      .catch(() => setError("Impossible de charger les documents."));
  }, [locale]);

  const accept = async () => {
    setBusy(true); setError("");
    try {
      await api.post("/legal/accept", { slugs: docs.map((d) => d.slug), context: "florist_login_reaccept" });
      if (onAccepted) await onAccepted();
    } catch (e) {
      setError(errText(e));
    } finally {
      // Always re-enable the button so a soft error (or reload that keeps the gate mounted)
      // never leaves the shop staring at a frozen loader.
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center p-4" data-testid="florist-legal-gate">
      <div className="bg-plaster w-full max-w-2xl max-h-[92vh] flex flex-col border border-brass">
        <div className="p-6 border-b border-brass-light flex items-center gap-3">
          <ShieldCheck className="text-brass shrink-0" size={22} />
          <div>
            <h1 className="font-display text-xl text-ink">{T.title}</h1>
            <p className="text-xs text-muted mt-1">{T.intro}</p>
          </div>
        </div>
        <div className="overflow-y-auto p-6 space-y-8 flex-1" dir={locale === "ar" ? "rtl" : "ltr"}>
          {error ? <p className="text-danger text-sm">{error}</p> : null}
          {(docs || []).map((d) => (
            <div key={d.slug} data-testid={`gate-doc-${d.slug}`}>
              <h2 className="font-display text-lg text-ink">{d.title}</h2>
              <p className="text-xs text-muted mb-3">{T.version} {d.version} · {d.effective_date}</p>
              <div className="text-sm border-t border-brass-light pt-3"><LegalDoc body={d.body} /></div>
            </div>
          ))}
          {docs && !docs.length ? <p className="text-sm text-muted">…</p> : null}
        </div>
        <div className="p-6 border-t border-brass-light space-y-3">
          <label className="flex items-start gap-3 text-sm text-charcoal cursor-pointer">
            <input type="checkbox" data-testid="gate-accept-checkbox" className="mt-0.5 shrink-0"
                   checked={checked} onChange={(e) => setChecked(e.target.checked)} />
            <span>{T.accept}</span>
          </label>
          <button data-testid="gate-accept-button" className="btn-primary w-full"
                  disabled={!checked || busy || !docs?.length} onClick={accept}>
            {busy ? "…" : T.button}
          </button>
        </div>
      </div>
    </div>
  );
}
